const typography = {
  fontFamily: '"Open Sans", sans-serif',
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightHeavy: 700,
  useNextVariants: true,
};

export const colors = {
  square_dark: "#343b42",
};

const palette = {
  type: "light",
  primary: {
    main: "#2996cc",
    light: "rgb(83, 171, 214)",
    dark: "rgb(28, 105, 142)",
    contrastText: "#f5f5f5",
  },
  secondary: {
    light: "#C4D8DD",
    main: "#93A7AB",
    dark: "#65787C",
  },
};

const overrides = {
  MuiTableCell: {
    head: {
      fontWeight: 600,
    },
  },
};

export default {
  palette,
  typography,
  overrides,
};
